<template>
  <el-dialog
      :visible.sync="dialogVisible"
      append-to-body
      title="新建报价单"
      width="500px"
      top="5vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        :model="priceSheet"
        class="form"
        label-width="100px">
      <el-form-item label="项目名称">
        <el-input v-model="priceSheet.itemName"/>
      </el-form-item>
      <el-form-item label="服务内容">
        <el-input v-model="priceSheet.serviceContent"/>
      </el-form-item>
      <el-form-item label="收费原因">
        <el-input v-model="priceSheet.chargeReason"/>
      </el-form-item>
      <el-form-item label="价格">
        <el-input v-model="priceSheet.price"/>
      </el-form-item>
      <el-form-item label="备注">
        <el-input v-model="priceSheet.note"/>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible=false">取消</el-button>
      <el-button type="primary" @click="handleSubmit">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>

  export default {
    name: "",
    components: {},
    data() {
      return {
        dialogVisible: false,
        index: 0,
        priceSheet: {
          pkid:0,
          itemName:"",
          serviceContent:"",
          chargeReason:"",
          price:"",
          note:"",
        },
      };
    },
    methods: {
      open(index,row) {
        this.dialogVisible = true;
        console.log(index);
        this.index = index;
        if (row) {
          this.priceSheet = row; 
        }
      },

      handleSubmit() {
        this.$emit("save-success", this.priceSheet,this.index);
        this.dialogVisible = false;
      },
      dialogClose() {
        // this.index = 0;
        // this.priceSheet.pkid = "";
        // this.priceSheet.itemName = "";
        // this.priceSheet.serviceContent = "";
        // this.priceSheet.chargeReason = "";
        // this.priceSheet.price = "";
        // this.priceSheet.note = "";
      },
  
    },
  };
</script>

<style lang="scss" scoped>
</style>
